import {Component, OnInit, ViewChild} from '@angular/core';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Program, Site, SiteTopology} from './domain/cloud-topology';
import {animate, state, style, transition, trigger,} from '@angular/animations';
import {ProgramService} from "./services/vpp/program.service";
import {TopologyService} from "./services/topology/topology.service";
import 'global-nav/dist/navbar.js';
import { NavbarService } from './services/navbar.service';

export interface SearchItem {
  id: string;
  name: string;
  type: string;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({
                opacity: 0
            })),
            transition('void <=> *', animate(1500)),
        ]),
    ],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(protected navbarService: NavbarService,
              private programService: ProgramService,
              private topologyService: TopologyService) {
  }

  title = 'control';
  appName = 'DER Optimization <br />Control Software';

  isCollapsed: boolean;
  displaySearch: boolean;
  isMenuOpen = true;
  contentMargin = 240;
  @ViewChild('siteSearch') siteSearch;

  public user: object;
  public model: Site;
  searchItems: SearchItem[];
  sites: SiteTopology[] = [];
  programs: Program[] = [];

  search = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    filter(term => term.length >= 2),
    map(term => this.searchItems.filter(searchItem => new RegExp(term, 'mi').test(searchItem.name)).slice(0, 10))
  )

  ngOnInit(): void {
    this.displaySearch = true;

    this.topologyService.getTopology().subscribe(sites => {
      this.sites = sites;

      this.programService.getPrograms().subscribe(programs => {
        this.programs = programs;
        this.buildSearchArray();
      });
    });
  }

  private buildSearchArray(): void {
    this.searchItems = [];
    if (this.sites && this.programs) {
      for (const site of this.sites) {
        this.searchItems.push({
          id: site.id,
          name: site.name,
          type: 'site'
        });
      }

      for (const program of this.programs) {
        this.searchItems.push({
          id: program.id,
          name: program.name,
          type: 'program',
        });
      }
    }
  }

  updateSideNav($event) {
    this.isMenuOpen = $event;
    if (!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
}
